import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, Subject, BehaviorSubject, pipe } from "rxjs";
import { EnvService } from "src/app/env.service";
import { filter, map, tap } from "rxjs/operators";
import * as moment from "moment";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "underscore";

function getXauth() {
  let loginData = JSON.parse(localStorage.getItem("loginData")) || {
    email: "demo@skillztank.com",
    firstName: "demo",
    lastName: "demo",
    role: "demo",
    _id: "idForDemoPurpose",
    token: "tokenForDemoPurpose",
  };
  let xAuth = loginData.token;
  return xAuth;
}

let httpOptions = {
  headers: new HttpHeaders({
    "Content-Type": "application/json", //,
    // 'x-auth': getXauth()
  }),
};

@Injectable({
  providedIn: "root",
})
export class TodosService {
  private todoDataSource = new Subject<any>();
  private todoChangeEventSource = new Subject<any>();
  private todoDataConfigSource = new Subject<any>();
  todoData$ = this.todoDataSource.asObservable();
  todoChangeEvent$ = this.todoChangeEventSource.asObservable();
  todoDataConfigEvent$ = this.todoDataConfigSource.asObservable();

  url;
  userid = (JSON.parse(localStorage.getItem("userData")) || { id: "" }).id;

  constructor(
    private env: EnvService,
    private http: HttpClient,
    private translate: TranslateService,
  ) {
    this.url = env.apiUrl;
  }

  passTodoConfigData(data) {
    this.todoDataConfigSource.next(data);
  }

  triggerTodoChangeEvent() {
    this.todoChangeEventSource.next(true);
  }

  passTodoData(data) {
    this.todoDataSource.next(data);
  }

  createTodo(data): Observable<any> {
    return this.http
      .post(this.url + "todo/createTodo/", data, httpOptions)
      .pipe(tap((res) => this.triggerTodoChangeEvent()));
  }
  getTodo(id): Observable<any> {
    return this.http.get(this.url + `todo/get?id=${id}`, httpOptions);
  }
  getTodos(start, end): Observable<any> {
    let userGroups = _.pluck(
      JSON.parse(localStorage.getItem("userGroups")),
      "_id",
    );
    return this.http
      .get(
        this.url +
          `todo/getTodos?startDate=${start}&endDate=${end}&userGroups=${userGroups}`,
        httpOptions,
      )
      .pipe(
        map((res: any) => {
          for (const e of res) {
            let roles = {};
            e.users.forEach((user) => {
              roles[user.id] = user.role;
            });

            // admin rights for groups
            userGroups.forEach(
              (member) => (e.isAdmin = roles[member] == "Admin" ? true : false),
            );

            // admin rights for user. must be last to override group privilege
            if (roles[this.userid])
              e.isAdmin = roles[this.userid] == "Admin" ? true : false;

            // e.isAdmin = e.users.find(user => user.id == this.userid && user.role == "Admin") ? true : false;
            //moment.locale(this.translate.currentLang);
            e.formattedStart = moment(e.start).format("LL");
            // TODO Faire la validation pour les groupes aussi
            // on devrait avoir l'information des groupes au niveau du UI
            // pour accélerer la validation
          }
          return res;
        }),
      );
  }
  deleteTodo(id): Observable<any> {
    return this.http
      .get(this.url + "todo/deleteTodo/?id=" + id, httpOptions)
      .pipe(tap((res) => this.triggerTodoChangeEvent()));
  }
  editTodo(id, type): Observable<any> {
    return this.http
      .get(this.url + `todo/setTodoType?id=${id}&type=${type}`, httpOptions)
      .pipe(tap((res) => this.triggerTodoChangeEvent()));
  }
}
